module.exports = __webpack_public_path__ + "static/img_4678-e548bb03567830b702e4e87f922fa1f3.webp";